
<ng-container>
  {{ getNumericValue() | appCurrency }}
</ng-container>
